import crown from "../Assets/others/crown.png";
import glassEmoji from "../Assets/others/glassEmoji.png";
import heroCharacter from "../Assets/others/hero.png";
import thumbsUp from "../Assets/others/thumbup.png";
import vectorBlue from "../Assets/others/vectorBlue.png";
import vectorOrange from "../Assets/others/vectorOrange.png";
import chatapp from "../Assets/projects/chatapp.png";
import dictionary from "../Assets/projects/dict.png";
import emailgenerator from "../Assets/projects/emailgenerator.png";
import googledocs from "../Assets/projects/googledoc.png";
import musicplayer from "../Assets/projects/musicplayer.png";
import quicknote from "../Assets/projects/quicknote.png";
import signeo from "../Assets/projects/signeo.png";
import translator from "../Assets/projects/translator.png";
import videoformatconverter from "../Assets/projects/videoformatconverter.png";
import weather from "../Assets/projects/weather.png";
import github from "../Assets/social/github.png";
import instagram from "../Assets/social/instagram.png";
import linkedin from "../Assets/social/linkedin.png";
import mail from "../Assets/social/mail.png";
import antdesign from "../Assets/tech/antdesign.svg";
import css from "../Assets/tech/css.png";
import eslint from "../Assets/tech/eslint.png";
import git from "../Assets/tech/git.png";
import githubb from "../Assets/tech/github.png";
import html from "../Assets/tech/html.png";
import js from "../Assets/tech/javascript.png";
import jest from "../Assets/tech/jest.svg";
import jira from "../Assets/tech/jira.svg";
import mui from "../Assets/tech/mui.png";
import nextjs from "../Assets/tech/nextjs.png";
import nodejs from "../Assets/tech/node.webp";
import py from "../Assets/tech/py.png";
import reactjs from "../Assets/tech/reactjs.png";
import redux from "../Assets/tech/redux.svg";
import slack from "../Assets/tech/slack.svg";

import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Github from "@iconscout/react-unicons/icons/uil-github";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import Twitter from "@iconscout/react-unicons/icons/uil-twitter";
import Wave from "../Assets/others/wave.png";

export const getMenuItemStyle = (menuOpen) => {
  if (document.documentElement.clientWidth <= 820) {
    return { right: !menuOpen && "-100%" };
  }
};

// SOCIAL ICONS
export const socialIcons = { github, instagram, linkedin, mail };

// HERO ICONS
export const heroIcons = {
  vectorBlue,
  vectorOrange,
  heroCharacter,
  glassEmoji,
  crown,
  thumbsUp,
};

// TECH ICONS
export const techIcons = {
  css,
  eslint,
  git,
  github,
  html,
  js,
  py,
  reactjs,
  githubb,
  nextjs,
};

// INTRODUCTION
export const introduction = {
  text: [
    "Hello there, I'm so happy you are here! :)",

    "My name is Puneet, I'm 27 and a self taught frontend developer based in Bikaner, Rajasthan. I have a strong passion for the technologies related UI and UX.",

    "Outside of my regular activities, I'm into sketching whenever I have some free time. I'm also a huge music lover and enjoy skating for fun.",

    "I'm continuously thrilled to partner with individuals and teams who wholeheartedly embrace my fervor for crafting extraordinary experiences. Your visit to my portfolio is deeply appreciated !",
  ],
};

// PROJECTS
export const projects = [
  {
    name: "AI Email Generator",
    description:
      "",
    image: emailgenerator,
    demo_link: "https://free-ai-email-generator.netlify.app/",
    key_skills: "React.js, Ant Design, Zustand, Express.js, Supabase",
    github: 'https://github.com/puneetsharma997/ai-email-generator'
  },
  {
    name: "Signeo - Sign PDFs online",
    description:
      "App for signing PDFs online for free, built with React, Sass, Zustand, and RSuite. It leverages react-pdf for viewing and pdf-lib to modify the pdf, enabling seamless PDF signing and downloading.",
    image: signeo,
    demo_link: "https://signeo.netlify.app/",
    key_skills: "React.js, Sass, Zustand, RSuite",
    github: 'https://github.com/puneetsharma997/signeo',
  },
  {
    name: "Video Format Converter",
    description:
      "A free, fully responsive video format converter built with React and Chakra UI, powered by FFmpeg. Upload any video and convert it to MP3, WAV, AAC, FLAC, or WMA. Fast, clean, and optimized for any device.",
    image: videoformatconverter,
    demo_link: "https://video-format-converter.netlify.app/",
    key_skills: "React.js, Chakra UI, FFmpeg.wasm",
    github: 'https://github.com/puneetsharma997/video-format-converter',
  },
  {
    name: "Google Docs",
    description:
      "",
    image: googledocs,
    demo_link: "https://doc-fs.web.app",
    key_skills: "MERN, Socket.io",
    github: '',
  },
  {
    name: "Quick Note",
    description:
      "",
    image: quicknote,
    demo_link: "https://quickk-note.netlify.app/",
    key_skills: "React.js, Sass, Zustand",
    github: 'https://github.com/puneetsharma997/quick-note',
  },
  {
    name: "Lumen Translate",
    description:
      "",
    image: translator,
    demo_link: "https://lumen-translate.netlify.app/",
    key_skills: "Solid.js, Kobalte UI, Python Fast API ",
    github: 'https://github.com/puneetsharma997/lumen-translate',
  },
  {
    name: "Dictionary",
    description:
      "",
    image: dictionary,
    demo_link: "https://dictionary-997.netlify.app/",
    key_skills: "React.js, Tailwind, APIs, Redux Toolkit",
    github: 'https://github.com/puneetsharma997/dictionary-app',
  },
  {
    name: "Realtime Chat Application",
    description:
      "",
    image: chatapp,
    demo_link: "https://talkrrchat.netlify.app/",
    key_skills: "React.js, Sass, Firebase Auth and DB",
    github: 'https://github.com/puneetsharma997/chat-app',
  },
  {
    name: "Weather Application",
    description:
      "",
    image: weather,
    demo_link: "https://weather-app-882dc.web.app/",
    key_skills: "React.js, APIs, Redux Toolkit",
    github: 'https://github.com/puneetsharma997/weather-app',
  },
  {
    name: "Music Player",
    description:
      "",
    image: musicplayer,
    demo_link: "https://music-app-95998.web.app/",
    key_skills: "React.js, Sass",
    github: 'https://github.com/puneetsharma997/music-player',
  },
];

// SKILLS
export const skills = [
  {
    id: "html",
    title: "HTML",
    icon: html,
    description:
      "I have a strong command of HTML for organizing web pages and generating meaningful content that can be accessed by all users.",
  },
  {
    id: "css",
    title: "CSS",
    icon: css,
    description:
      "I possess expertise in utilizing CSS to design web pages and craft visually captivating layouts that enhance the overall user experience.",
  },
  {
    id: "javascript",
    title: "JavaScript",
    icon: js,
    description:
      "I have substantial experience in employing JavaScript to introduce interactivity and functionality into web pages, resulting in dynamic user interfaces.",
  },
  {
    id: "react",
    title: "React",
    icon: reactjs,
    description:
      "I am well-versed in React, proficient in creating reusable components and managing application state using hooks and context.",
  },
  {
    id: "nextjs",
    title: "Next.js",
    icon: nextjs,
    description:
      "I have used Next.js for building web applications with its file-based routing system and SEO-friendly architecture to improve site structure and discoverability.",
  },
  {
    id: "antdesign",
    title: "Ant Design",
    icon: antdesign,
    description:
      "I utilize Ant Design's comprehensive set of components (buttons, forms), patterns, and guidelines to create seamless and intuitive web applications.",
  },
  {
    id: "mui",
    title: "Material UI",
    icon: mui,
    description:
      "I am skilled in using Material UI’s component library, theming capabilities, and layout tools to develop clean, responsive, and consistent web applications.",
  },
  {
    id: "redux",
    title: "Redux",
    icon: redux,
    description:
      "I possess expertise in writing actions, reducers, and selectors to handle application logic and state updates in Redux.",
  },
  {
    id: "eslint",
    title: "Eslint",
    icon: eslint,
    description:
      "I utilize ESLint to identify and resolve code issues, as well as standardize the structure of my projects. With ESLint, I ensure code quality and consistency.",
  },
  {
    id: "jest",
    title: "Jest",
    icon: jest,
    description:
      "I am well-versed in writing test cases using Jest's features such as test assertions, mocking and coverage reports to ensure code quality.",
  },
  {
    id: "git",
    title: "Git",
    icon: git,
    description:
      "I am proficient in Git, managing code changes, collaborating with others, and resolving conflicts effectively.",
  },
  {
    id: "github",
    title: "GitHub",
    icon: githubb,
    description:
      "I am skilled in using GitHub for seamless project collaboration, code sharing, and issue tracking. I efficiently create and manage repositories throught GitHub.",
  },
  {
    id: "node",
    title: "Node",
    icon: nodejs,
    description:
      "I prefer using Node as my runtime environment over Yarn. I have expertise in leveraging Node.js to develop powerful and scalable web applications.",
  },
  {
    id: "jira",
    title: "Jira",
    icon: jira,
    description:
      "I have experience in creating and managing user stories, epics, tasks, and subtasks within Jira to facilitate project planning and execution.",
  },
  {
    id: "slack",
    title: "Slack",
    icon: slack,
    description:
      "I have strong understanding of Slack's features and functionalities, including instant messaging, file sharing, voice/video calls, and integrations.",
  },
];

// FOOTER ICONS
export const footerIcons = { Facebook, Twitter, Linkedin, Wave, Github };
